import Vue from 'vue'

import './styles/quasar.styl'
import '@quasar/extras/material-icons/material-icons.css'
import {
    Quasar,
    QSelect,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QIcon,
    QCheckbox,
    QVirtualScroll,
    QBtn,
    QLinearProgress,
    QMenu,
    ClosePopup
} from 'quasar'

Vue.use(Quasar, {
    config: {},
    components: {
        QSelect,
        QList,
        QItem,
        QItemSection,
        QItemLabel,
        QIcon,
        QCheckbox,
        QVirtualScroll,
        QBtn,
        QLinearProgress,
        QMenu
    },
    directives: {
        ClosePopup
    },
    plugins: {
    }
})
